import { render, staticRenderFns } from "./TimeAgo.vue?vue&type=template&id=016710b4&"
import script from "./TimeAgo.vue?vue&type=script&lang=js&"
export * from "./TimeAgo.vue?vue&type=script&lang=js&"
import style0 from "./TimeAgo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports